var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 16.2498C3.33334 15.6973 3.55283 15.1674 3.94353 14.7767C4.33423 14.386 4.86413 14.1665 5.41667 14.1665H16.6667",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 1.6665H16.6667V18.3332H5.41667C4.86413 18.3332 4.33423 18.1137 3.94353 17.723C3.55283 17.3323 3.33334 16.8024 3.33334 16.2498V3.74984C3.33334 3.1973 3.55283 2.6674 3.94353 2.2767C4.33423 1.886 4.86413 1.6665 5.41667 1.6665V1.6665Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a64bd5af5975310b1b1326cb7fa3e412.svg";
export { ForwardRef as ReactComponent };